"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserNonce = void 0;
const viem_1 = require("viem");
const constants_1 = require("../constants");
const relayAddress_1 = require("./relayAddress");
const getPublicClient_1 = require("./getPublicClient");
const getUserNonce = (payload, config) => __awaiter(void 0, void 0, void 0, function* () {
    const { account, type, client } = payload;
    const chainId = BigInt(yield client.getChainId());
    const publicClient = (0, getPublicClient_1.getPublicClient)(client);
    const nonce = yield publicClient.readContract({
        abi: (0, viem_1.parseAbi)(constants_1.USER_NONCE_ABI),
        address: (0, relayAddress_1.getGelatoRelayERC2771Address)({ chainId, type }, config),
        functionName: "userNonce",
        args: [account],
    });
    return nonce;
});
exports.getUserNonce = getUserNonce;
